app.controller('ridesIndexCtrl', [
    '$scope', '$rootScope', '$http', 'mdContentService', function ($scope, $rootScope, $http, mdContentService) {
    	var vm = this;

    	vm.rides = [];
    	vm.loaded = false;
    	$http.get('/api/rides').then(function(response) {
    		vm.loaded = true;
    		vm.rides = response.data.items;

            mdContentService.triggerSyntheticScrollEvent();
    	});

    	$scope.delete = function(exerciseSet, $event) {
    		console.log("nyi");
    	}
    }
]);